function initSantarcCarousel(root) {
  const track = root.querySelector('[data-santarc-track]');
  const slides = Array.from(root.querySelectorAll('[data-santarc-slide]'));
  const dotsWrap = root.querySelector('[data-santarc-dots]');
  const prevBtn = root.querySelector('[data-santarc-prev]');
  const nextBtn = root.querySelector('[data-santarc-next]');
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!track || slides.length === 0) return;

  let index = 0;
  let timer = null;

  dotsWrap.innerHTML = '';
  const dots = slides.map((_, i) => {
    const dot = document.createElement('button');
    dot.type = 'button';
    dot.className = 'santarc-promo__dot';
    dot.setAttribute('aria-label', `Ir a la promoción ${i + 1}`);
    dot.addEventListener('click', () => goTo(i));
    dotsWrap.appendChild(dot);
    return dot;
  });

  function render() {
    track.style.transform = `translateX(-${index * 100}%)`;
    dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
  }

  function goTo(i) {
    index = (i + slides.length) % slides.length;
    render();
  }

  function next() { goTo(index + 1); }
  function prev() { goTo(index - 1); }

  function startAutoplay() {
    if (prefersReducedMotion || slides.length < 2) return;
    stopAutoplay();
    timer = setInterval(next, 5000);
  }

  function stopAutoplay() {
    if (timer) clearInterval(timer);
    timer = null;
  }

  prevBtn?.addEventListener('click', () => { prev(); startAutoplay(); });
  nextBtn?.addEventListener('click', () => { next(); startAutoplay(); });
  root.addEventListener('mouseenter', stopAutoplay);
  root.addEventListener('mouseleave', startAutoplay);

  render();
  startAutoplay();
}

document.querySelectorAll('[data-santarc-carousel]').forEach(initSantarcCarousel);

document.addEventListener('shopify:section:load', (event) => {
  const carousel = event.target.querySelector('[data-santarc-carousel]');
  if (carousel) initSantarcCarousel(carousel);
});
